import * as React from "react";

import { DatasetsList } from "@/shared/components/datasets/DatasetsList";
import { useDatasetBulkActions } from "@/shared/components/datasets/useDatasetBulkActions";
import type { Filter } from "@/shared/components/ResourceView";

import { useDeviceContext } from "../Device/useDeviceContext";

/**
 * Route component for the device dataset page
 */
export function DeviceDatasets() {
  const { deviceId } = useDeviceContext();
  const bulkActions = useDatasetBulkActions();

  const scope = React.useMemo<Filter[]>(
    () => [
      {
        type: "string",
        field: "device_id",
        comparator: "EQUALS",
        values: [deviceId],
      },
    ],
    [deviceId],
  );

  return (
    <>
      <DatasetsList
        scope={scope}
        noRowsContent="No datasets for this device"
        selectionOptions={bulkActions.selectionOptions}
      />
      {bulkActions.addToCollectionDialog}
    </>
  );
}
